import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { get } from 'lodash';

import { routesConstants } from '../../constants';
import Icons from '../../components/icons';
import { ICONS } from '../../constants/icons.constants';
import { Button } from '../../kaya';
import axios from '../../axios';
import userStore from '../../zustand/user.store';
import { userActions } from '../../actions';
import { TOKENS } from '../../constants/general.constants';
import logo from '../../assets/Logo.png';

import styles from './EmailVerify.module.scss';

const EmailVerify = () => {
  const {
    setUser,
    user,
    defaultUser,
    setAuthentication,
    authenticate,
    userOffline,
  } = userStore((state) => ({
    setUser: state.setUser,
    user: state.user,
    defaultUser: state.defaultUser,
    setAuthentication: state.setAuthentication,
    authenticate: state.authenticate,
    userOffline: state.userOffline,
  }));
  const [searchParams, setSeararams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const ref = useRef(false);

  useEffect(() => {
    if (ref.current) return;

    const verifyEmail = async () => {
      ref.current = true;

      if (token) {
        const data = await userActions.verifyEmailAction({
          token,
          userOffline,
        });
        if (!data.success) return;
        setUser({
          ...defaultUser,
          id: get(data, 'data.id', ''),
        });
        setAuthentication({
          isAuthenticated: true,
          isPhoneVerified: false,
          isBusinessVerified: false,
          isPrimium: false,
        });
        localStorage.setItem(
          TOKENS.REFRESH_TOKEN,
          get(data, 'data.refresh_token', '')
        );
        axios.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${get(data, 'data.access_token', '')}`;
        navigate(routesConstants.ROUTES.PERSONAL_INFO);
      }
    };
    verifyEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.EmailVerify}>
      <div className={styles.logo}>
        {/* <Icons type={ICONS.LOGO} /> */}
        <img src={logo} alt='logo' />
      </div>
      <div className={styles.box}>
        <div className={styles.check}>
          <Icons type={ICONS.CHECKLOGO} />
        </div>
        <p className={styles.desc}>Successfully Verified</p>
        <p className={styles.desc2}>
          Congratulations! Your email address has been successfully
          verified.
        </p>
        <Button
          className={styles.btn}
          onClick={() => {
            navigate(routesConstants.ROUTES.LOGIN);
          }}
          type='Primary'>
          Done
        </Button>
      </div>
    </div>
  );
};

export default EmailVerify;
